import Analytics from 'analytics'
import googleAnalyticsPlugin from '@analytics/google-analytics'
import googleAnalyticsV3Plugin from '@analytics/google-analytics-v3'

export function initialize(trackingId) {
    let plugins = [];
    if (trackingId.startsWith('UA-')) {
        plugins.push(googleAnalyticsV3Plugin({trackingId}));
    } else {
        plugins.push(googleAnalyticsPlugin({measurementIds: [trackingId]}));
    }
 
    window.__analytics = Analytics({ app: 'polyphony', plugins });

    /* Backwards Compat */
    if (window.ga) {
        window.gtag = window.ga;
    }

    return () => {
        delete window.__analytics;
        if (window.gtag) delete window.gtag;
        if (window.ga) delete window.ga;
    };
}

export function pageView({title, path, loc}) {
    if (!window.__analytics) {
        polyphony.debug('Failed attempted pageview: analytics is not initialized.');
        return;
    }

    polyphony.debug('---- Begin Google Analytics SPA page view ----');
    window.__analytics.page({
        title: (title ?? ''),
        path,
        url: loc
    });
    polyphony.debug('---- End Google Analytics SPA page view ----');
}

